import { Link } from "react-router-dom";
import { Leaf, ArrowLeft } from "lucide-react";
import Footer from "@/components/Footer";

const Refund = () => {
  return (
    <div className="min-h-screen bg-[#F8F6F1] flex flex-col" data-testid="refund-page">
      {/* Nav */}
      <nav className="sticky top-0 z-50 bg-[#F8F6F1]/80 backdrop-blur-xl border-b border-[#D4C9B8]/30">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2.5">
            <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#9FB89F] to-[#7A9B7E] flex items-center justify-center">
              <Leaf className="w-4 h-4 text-white" />
            </div>
            <span className="font-serif text-xl font-medium text-[#2D3A2D]">My Story</span>
          </Link>
          <Link to="/" className="flex items-center gap-1.5 font-sans text-sm text-[#7A8A7A] hover:text-[#2D3A2D] transition-colors" data-testid="refund-back-home">
            <ArrowLeft className="w-4 h-4" /> Back to Home
          </Link>
        </div>
      </nav>

      {/* Content */}
      <main className="flex-1 max-w-3xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <h1 className="font-serif text-4xl sm:text-5xl font-medium text-[#2D3A2D] mb-3 tracking-tight" data-testid="refund-title">
          Cancellation and Refund Policy
        </h1>
        <p className="font-sans text-sm text-[#7A8A7A] mb-10">Last updated: {new Date().toLocaleDateString("en-IN", { month: "long", year: "numeric" })}</p>

        <div className="prose-custom space-y-8">
          <p className="font-sans text-base leading-relaxed text-[#4A5D4A]">
            Because my-story.in provides personalized digital goods and custom-printed physical books, our refund policy is structured as follows:
          </p>

          <section>
            <h2 className="font-serif text-xl font-medium text-[#2D3A2D] mb-3">1. Digital PDF Downloads (Track A)</h2>
            <p className="font-sans text-base leading-relaxed text-[#4A5D4A]">
              Due to the instant nature of digital goods, all sales of digital PDF downloads are final. Once the PDF has been generated and unlocked on your dashboard, no refunds or cancellations can be processed.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl font-medium text-[#2D3A2D] mb-3">2. Physical Printed Books (Track B)</h2>
            <div className="space-y-4">
              <div>
                <h3 className="font-serif text-lg font-medium text-[#2D3A2D] mb-2">Cancellations</h3>
                <p className="font-sans text-base leading-relaxed text-[#4A5D4A]">
                  Physical books are custom-printed. You may cancel your order for a partial refund (Difference of Digital and Physical) only within <strong className="text-[#2D3A2D]">2 hours</strong> of placing the order, before the files are sent to the printing press. Once printing begins, the order cannot be cancelled.
                </p>
              </div>
              <div>
                <h3 className="font-serif text-lg font-medium text-[#2D3A2D] mb-2">Refunds / Replacements</h3>
                <p className="font-sans text-base leading-relaxed text-[#4A5D4A]">
                  If your physical book arrives damaged, misprinted, or defective due to a manufacturing error, please contact us within 7 days of delivery with photographic proof. We will happily issue a free replacement. We do not offer refunds for typos, spelling errors, or low-resolution photos submitted by the user.
                </p>
              </div>
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Refund;
